import { useEffect, useState } from "react";
import axios from "axios";
import { Appid, BaseUrl, Imei, LoginTypeID, SerialNo, Version } from "../../enum/enum";
import { useLoader } from "../../context/loaderContext";
import { useAuth } from "../../context/authContext";
import Layout from "../../layout/layout";
import moment from "moment";


const LevelWiseUserCount = () => {
    const { showLoader, hideLoader } = useLoader();
    const {
        token,
        sessionId,
        userId,
    } = useAuth();

    const [levelWiseUserCountReport, setLevelWiseUserCountReport] = useState([]);
    const [levelWiseUserIdReport, setLevelWiseUserIdReport] = useState([]);
    const [inputSlotId, setInputSlotId] = useState(() => {
        const storedSlotId = localStorage.getItem("slotId");
        return storedSlotId ? parseInt(storedSlotId, 10) : 0;
    });

    const [levelDetails, setLevelDetails] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [showModal1, setShowModal1] = useState(false);
    const [selectedLevel, setSelectedLevel] = useState(null);

    useEffect(() => {
        const storedSlot = localStorage.getItem("slotId");
        if (storedSlot) getData(storedSlot);
    }, []);

    const handleSearch = () => {
        if (!inputSlotId) {
            alert("Please enter a Slot ID");
            return;
        }

        localStorage.setItem("slotId", inputSlotId);

        getData(inputSlotId);
    };


    const handleLevelClick = async (level) => {
        try {
            setSelectedLevel(level);
            showLoader();
            const url = `${BaseUrl}dashboard/LevelWiseUserPurchaseDetails`;
            const obj = {
                appSession: {
                    appid: Appid,
                    imei: Imei,
                    loginTypeID: LoginTypeID,
                    regKey: "",
                    serialNo: SerialNo,
                    session: token,
                    sessionID: sessionId,
                    userID: userId,

                    // "sessionID": 603997,
                    // "session": "0dda9d096e1a79ee7d3b810e1067f3f2",
                    // "userID": 10459,
                    uid: 0,
                    version: Version
                },
                request: {
                    strUserId: userId,
                    // "strUserId": 10459,
                    "CommonInt": inputSlotId,
                    "LevelNo": level
                }
            };

            showLoader();
            const res = await axios.post(url, obj);

            if (res.data?.statuscode === 1 && Array.isArray(res.data.data)) {
                setLevelDetails(res.data.data);
                setShowModal(true);
            } else {
                setLevelDetails([]);
                alert("No data found for this level.");
            }


            hideLoader();
        } catch (e) {
            hideLoader();
            console.error("Error fetching level data:", e.message);
        }
    };



    const getData = async () => {
        try {
            const url = `${BaseUrl}dashboard/LevelWiseUserCount`;
            const obj = {
                "appSession": {
                    "appid": Appid,
                    "imei": Imei,
                    "loginTypeID": LoginTypeID,
                    "regKey": "",
                    "serialNo": SerialNo,

                    "userID": userId,
                    // "sessionID": 603997,
                    // "session": "0dda9d096e1a79ee7d3b810e1067f3f2",
                    // "userID": 10459,
                    session: token,
                    sessionID: sessionId,
                    userID: userId,
                    "uid": 0,
                    "version": Version

                },
                "request": {
                    "strUserId": userId,
                    // "strUserId": 10459,
                    CommonInt: inputSlotId
                }
            }

            showLoader();

            const res = await axios.post(url, obj);

            if (res.data?.statuscode == 1) {
                setLevelWiseUserCountReport(res.data.data || []);
            } else {
                setLevelWiseUserCountReport([]);
            }

            hideLoader();
        } catch (e) {
            hideLoader();
            console.log(e.message);
        }
    }


    const handleUserClick = async (clickedUserId) => {
        try {
            const url = `${BaseUrl}dashboard/LevelTargetReport`;
            const obj = {
                appSession: {
                    appid: Appid,
                    imei: Imei,
                    loginTypeID: LoginTypeID,
                    regKey: "",
                    serialNo: SerialNo,
                    "session": token,
                    "sessionID": sessionId,
                    userID: userId,
                    // "sessionID": 603997,
                    // "session": "0dda9d096e1a79ee7d3b810e1067f3f2",
                    // "userID": 10459,
                    uid: 0,
                    version: Version,
                },
                request: {
                    strUserId: clickedUserId,
                    CommonInt: inputSlotId,
                },
            };

            showLoader();
            const res = await axios.post(url, obj);

            if (res.data?.statuscode === 1) {
                setLevelWiseUserIdReport(res.data.data || []);
                setShowModal1(true);
            }
            else if (res.data?.statuscode === -1) {

                setLevelWiseUserIdReport(res.data.data || []);
                setShowModal1(true);

            } else {
                setLevelWiseUserIdReport([]);
            }

            hideLoader();
        } catch (e) {
            hideLoader();
            console.error("Error fetching user details:", e.message);
        }
    };


    useEffect(() => {
        getData();
    }, []);

    return (
        <Layout>
            <main>
                <div className="pageWrapper maxWidth pt-0">
                    <div className="container-fluid income-report-main">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="desktop-card card">
                                    <div className="card-header mb-3">
                                        <h5> Level User Count Report </h5>
                                    </div>

                                    <div className="mx-md-3 mx-0 table-filter"
                                        style={{
                                            display: 'grid',
                                            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                                            gap: '16px'
                                        }}
                                    >

                                        <div>
                                            <label className="form-label">Slot ID</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder="Enter Slot ID..."
                                                value={inputSlotId}
                                                onChange={(e) => setInputSlotId(parseInt(e.target.value, 10) || 0)}

                                            />
                                        </div>

                                        <div className="d-flex-end">
                                            <button
                                                type="button"

                                                onClick={handleSearch}
                                                className="cus-btn-submit"
                                            >Search</button>
                                        </div>
                                    </div>

                                    <div className="desktop-view-only card-body px-0">
                                        {
                                            levelWiseUserCountReport?.length > 0 ? (
                                                <div className="table-responsive">
                                                    <table className="table align-middle mb-0 bg-hover-effect">
                                                        <thead>
                                                            <tr>
                                                                <th scope="col">#</th>

                                                                <th scope="col">Level</th>
                                                                <th scope="col"> User Count</th>
                                                                <th scope="col">Total Unit</th>


                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                levelWiseUserCountReport?.map((el, i) => (
                                                                    <tr key={i}>
                                                                        <td>{i + 1}</td>
                                                                        <td>
                                                                            <span
                                                                                onClick={() => handleLevelClick(el.level)}
                                                                                style={{
                                                                                    display: "inline-block",
                                                                                    padding: "4px 10px",
                                                                                    backgroundColor: "#FBE354",
                                                                                    border: "1px solid #00acc1",
                                                                                    borderRadius: "6px",
                                                                                    cursor: "pointer",
                                                                                    color: "#006064",
                                                                                    fontWeight: "500",
                                                                                    transition: "all 0.2s ease-in-out"
                                                                                }}
                                                                                onMouseEnter={(e) => (e.target.style.backgroundColor = "#e0f7fa")}
                                                                                onMouseLeave={(e) => (e.target.style.backgroundColor = "#FBE354")}
                                                                            >
                                                                                {el.level}
                                                                            </span>
                                                                        </td>
                                                                        <td>{el.count}</td>
                                                                        <td>{el.totalBussiness}</td>


                                                                    </tr>
                                                                ))
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            ) : (
                                                <div>
                                                    <p className="text-center">No records found.</p>
                                                </div>
                                            )}
                                    </div>
                                    <div className="mobile-view-only mt-3">
                                        {levelWiseUserCountReport?.length > 0 ? (
                                            levelWiseUserCountReport.map((el, i) => (
                                                <div key={i} className="card mb-3 p-3 bg-hover-effect rounded shadow-sm">
                                                    <div className="d-flex justify-content-between align-items-center my-2">
                                                        <span className="badge bg-dark">#{i + 1}</span>
                                                        <span className="small">{el.entryDate}</span>
                                                    </div>



                                                    <div className="d-flex justify-content-between align-items-center my-1">
                                                        <strong>Level:</strong>

                                                        <p className="mb-0 f-w-500">
                                                            <span
                                                                onClick={() => handleLevelClick(el.level)}
                                                                style={{
                                                                    display: "inline-block",
                                                                    padding: "4px 10px",
                                                                    backgroundColor: "#FBE354",
                                                                    border: "1px solid #00acc1",
                                                                    borderRadius: "6px",
                                                                    cursor: "pointer",
                                                                    color: "#006064",
                                                                    fontWeight: "500",
                                                                    transition: "all 0.2s ease-in-out"
                                                                }}
                                                                onMouseEnter={(e) => (e.target.style.backgroundColor = "#e0f7fa")}
                                                                onMouseLeave={(e) => (e.target.style.backgroundColor = "#FBE354")}
                                                            >
                                                                {el.level}
                                                            </span>
                                                        </p>
                                                    </div>
                                                    <div className="d-flex justify-content-between align-items-center my-1">
                                                        <strong> User Count:</strong>
                                                        <p className="mb-0 f-w-500">{el.count}</p>
                                                    </div>


                                                    <div className="d-flex justify-content-between align-items-center my-1">
                                                        <strong>Total Unit:</strong>
                                                        <p className="mb-0 f-w-500">{el.totalBussiness}</p>
                                                    </div>

                                                </div>
                                            ))
                                        ) : (
                                            <p className="text-center">No records found.</p>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>



            {showModal && (
                <div
                    className="modal fade show"
                    style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
                >
                    <div className="modal-dialog modal-lg modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Level {selectedLevel} Details</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => setShowModal(false)}
                                ></button>
                            </div>
                            <div className="modal-body">
                                <div className="pageWrapper maxWidth pt-0">
                                    <div className="container-fluid income-report-main">
                                        <div className="row">
                                            <div className="col-lg-12">
                                                <div className="desktop-card card">

                                                    <div className="desktop-view-only card-body px-0">
                                                        {
                                                            levelDetails?.length > 0 ? (
                                                                <div className="table-responsive">
                                                                    <table className="table align-middle mb-0 bg-hover-effect">
                                                                        <thead>
                                                                            <tr>
                                                                                <th scope="col">#</th>

                                                                                <th>User ID</th>
                                                                                <th>Name</th>
                                                                                <th>Unit Purchased</th>
                                                                                <th>isUnit Purchased</th>

                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {
                                                                                levelDetails?.map((el, i) => (
                                                                                    <tr key={i}>
                                                                                        <td>{i + 1}</td>

                                                                                        {/* <td>
                                                                                            {el.isProductPurchased ? (
                                                                                                <span
                                                                                                    style={{
                                                                                                        display: "inline-block",
                                                                                                        padding: "4px 10px",
                                                                                                        backgroundColor: "#FBE354",
                                                                                                        border: "1px solid #00acc1",
                                                                                                        borderRadius: "6px",
                                                                                                        cursor: "pointer",
                                                                                                        color: "#006064",
                                                                                                        fontWeight: "500",
                                                                                                        transition: "all 0.2s ease-in-out",
                                                                                                    }}
                                                                                                    onMouseEnter={(e) => (e.target.style.backgroundColor = "#e0f7fa")}
                                                                                                    onMouseLeave={(e) => (e.target.style.backgroundColor = "#FBE354")}
                                                                                                    onClick={() => handleUserClick(el.userID)}
                                                                                                >
                                                                                                    {el.userID}
                                                                                                </span>
                                                                                            ) : (
                                                                                                <span
                                                                                                    style={{
                                                                                                        display: "inline-block",
                                                                                                        padding: "4px 10px",
                                                                                                        backgroundColor: "#f1f1f1",
                                                                                                        border: "1px solid #ccc",
                                                                                                        borderRadius: "6px",
                                                                                                        color: "#888",
                                                                                                        cursor: "not-allowed",
                                                                                                    }}
                                                                                                >
                                                                                                    {el.userID}
                                                                                                </span>
                                                                                            )}
                                                                                        </td> */}
                                                                                        <td>
                                                                                            <span
                                                                                                style={{
                                                                                                    display: "inline-block",
                                                                                                    padding: "4px 10px",
                                                                                                    backgroundColor: "#FBE354",
                                                                                                    border: "1px solid #00acc1",
                                                                                                    borderRadius: "6px",
                                                                                                    cursor: "pointer",
                                                                                                    color: "#006064",
                                                                                                    fontWeight: "500",
                                                                                                    transition: "all 0.2s ease-in-out",
                                                                                                }}
                                                                                                onMouseEnter={(e) => (e.target.style.backgroundColor = "#e0f7fa")}
                                                                                                onMouseLeave={(e) => (e.target.style.backgroundColor = "#FBE354")}
                                                                                                onClick={() => handleUserClick(el.userID)} // 👈 always clickable
                                                                                            >
                                                                                                {el.userID}
                                                                                            </span>
                                                                                        </td>


                                                                                        <td>{el.name}</td>
                                                                                        <td>{el.productPurchased}</td>


                                                                                        <td>
                                                                                            <span
                                                                                                className={`badge ${el.isProductPurchased ? "bg-success" : "bg-danger"
                                                                                                    }`}
                                                                                            >
                                                                                                {el.isProductPurchased ? "Purchased" : "Not Puchased"}
                                                                                            </span>
                                                                                        </td>
                                                                                    </tr>
                                                                                ))
                                                                            }
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            ) : (
                                                                <div>
                                                                    <p className="text-center">No records found.</p>
                                                                </div>
                                                            )}
                                                    </div>
                                                    <div className="mobile-view-only mt-3">
                                                        {levelDetails?.length > 0 ? (
                                                            levelDetails.map((el, i) => (
                                                                <div key={i} className="card mb-3 p-3 bg-hover-effect rounded shadow-sm">
                                                                    <div className="d-flex justify-content-between align-items-center my-2">
                                                                        <span className="badge bg-dark">#{i + 1}</span>
                                                                        <span className="small">{el.entryDate}</span>
                                                                    </div>



                                                                    <div className="d-flex justify-content-between align-items-center my-1">
                                                                        <strong>User Id:</strong>

                                                                        {/* <p className="mb-0 f-w-500">

                                                                            {el.isProductPurchased ? (
                                                                                <span
                                                                                    style={{
                                                                                        display: "inline-block",
                                                                                        padding: "4px 10px",
                                                                                        backgroundColor: "#FBE354",
                                                                                        border: "1px solid #00acc1",
                                                                                        borderRadius: "6px",
                                                                                        cursor: "pointer",
                                                                                        color: "#006064",
                                                                                        fontWeight: "500",
                                                                                        transition: "all 0.2s ease-in-out",
                                                                                    }}
                                                                                    onMouseEnter={(e) => (e.target.style.backgroundColor = "#e0f7fa")}
                                                                                    onMouseLeave={(e) => (e.target.style.backgroundColor = "#FBE354")}
                                                                                    onClick={() => handleUserClick(el.userID)}
                                                                                >
                                                                                    {el.userID}
                                                                                </span>
                                                                            ) : (
                                                                                <span
                                                                                    style={{
                                                                                        display: "inline-block",
                                                                                        padding: "4px 10px",
                                                                                        backgroundColor: "#f1f1f1",
                                                                                        border: "1px solid #ccc",
                                                                                        borderRadius: "6px",
                                                                                        color: "#888",
                                                                                        cursor: "not-allowed",
                                                                                    }}
                                                                                >
                                                                                    {el.userID}
                                                                                </span>
                                                                            )}


                                                                        </p> */}
                                                                        <p className="mb-0 f-w-500">
                                                                            <span
                                                                                style={{
                                                                                    display: "inline-block",
                                                                                    padding: "4px 10px",
                                                                                    backgroundColor: "#FBE354",
                                                                                    border: "1px solid #00acc1",
                                                                                    borderRadius: "6px",
                                                                                    cursor: "pointer",
                                                                                    color: "#006064",
                                                                                    fontWeight: "500",
                                                                                    transition: "all 0.2s ease-in-out",
                                                                                }}
                                                                                onMouseEnter={(e) => (e.target.style.backgroundColor = "#e0f7fa")}
                                                                                onMouseLeave={(e) => (e.target.style.backgroundColor = "#FBE354")}
                                                                                onClick={() => handleUserClick(el.userID)} // 👈 always clickable
                                                                            >
                                                                                {el.userID}
                                                                            </span>
                                                                        </p>

                                                                    </div>
                                                                    <div className="d-flex justify-content-between align-items-center my-1">
                                                                        <strong> Name:</strong>
                                                                        <p className="mb-0 f-w-500">{el.name}</p>
                                                                    </div>


                                                                    <div className="d-flex justify-content-between align-items-center my-1">
                                                                        <strong>Unit Purchased:</strong>
                                                                        <p className="mb-0 f-w-500">{el.productPurchased}</p>
                                                                    </div>
                                                                    <div className="d-flex justify-content-between align-items-center my-1">
                                                                        <strong>isUnit Purchase:</strong>
                                                                        <p className="mb-0 f-w-500"> <span
                                                                            className={`badge ${el.isProductPurchased ? "bg-success" : "bg-danger"
                                                                                }`}
                                                                        >
                                                                            {el.isProductPurchased ? "Purchased" : "Not Puchased"}
                                                                        </span></p>
                                                                    </div>
                                                                </div>
                                                            ))
                                                        ) : (
                                                            <p className="text-center">No records found.</p>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}


            {showModal1 && (
                <div
                    className="modal fade show"
                    style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
                >
                    <div className="modal-dialog modal-lg modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Unit Details</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => setShowModal1(false)}
                                ></button>
                            </div>
                            <div className="modal-body">
                                <div className="pageWrapper maxWidth pt-0">
                                    <div className="container-fluid income-report-main">
                                        <div className="row">
                                            <div className="col-lg-12">
                                                <div className="desktop-card card">

                                                    <div className="desktop-view-only card-body px-0">
                                                        {
                                                            levelWiseUserIdReport?.length > 0 ? (
                                                                <div className="table-responsive">
                                                                    <table className="table align-middle mb-0 bg-hover-effect">
                                                                        <thead>
                                                                            <tr>


                                                                                <th scope="col">#</th>
                                                                                <th scope="col">SlotId</th>
                                                                                <th scope="col"> UserId</th>
                                                                                <th scope="col">Name</th>
                                                                                <th scope="col">OldUnit</th>
                                                                                <th scope="col">RequiredUnit</th>
                                                                                <th scope="col">CompletedUnit</th>
                                                                                <th scope="col">EntryDate</th>

                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {
                                                                                levelWiseUserIdReport?.map((el, i) => (
                                                                                    <tr key={i}>
                                                                                        <td>{i + 1}</td>
                                                                                        <td>{el.slotID}</td>
                                                                                        <td>{el.userID}</td>
                                                                                        <td>{el.name}</td>
                                                                                        <td>{el.oldProduct}</td>
                                                                                        <td>{el.requiredProduct}</td>
                                                                                        <td>{el.completedProduct}</td>
                                                                                        <td>{el.entryDate}</td>
                                                                                    </tr>
                                                                                ))
                                                                            }
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            ) : (
                                                                <div>
                                                                    <p className="text-center">No records found.</p>
                                                                </div>
                                                            )}
                                                    </div>

                                                    <div className="mobile-view-only mt-3">
                                                        {levelWiseUserIdReport?.length > 0 ? (
                                                            levelWiseUserIdReport.map((el, i) => (
                                                                <div key={i} className="card mb-3 p-3 bg-hover-effect rounded shadow-sm">
                                                                    <div className="d-flex justify-content-between align-items-center my-2">
                                                                        <span className="badge bg-dark">#{i + 1}</span>
                                                                        <span className="small">{el.entryDate}</span>
                                                                    </div>

                                                                    <div className="d-flex justify-content-between align-items-center my-1">
                                                                        <strong>Slot Id:</strong>
                                                                        <p className="mb-0 f-w-500">{el.slotID}</p>
                                                                    </div>
                                                                    <div className="d-flex justify-content-between align-items-center my-1">
                                                                        <strong>userID:</strong>
                                                                        <p className="mb-0 f-w-500">{el.userID}</p>
                                                                    </div>
                                                                    <div className="d-flex justify-content-between align-items-center my-1">
                                                                        <strong>Name:</strong>
                                                                        <p className="mb-0 f-w-500">{el.name}</p>
                                                                    </div>
                                                                    <div className="d-flex justify-content-between align-items-center my-1">
                                                                        <strong>Old Unit :</strong>
                                                                        <p className="mb-0 f-w-500">{el.oldProduct}</p>
                                                                    </div>
                                                                    <div className="d-flex justify-content-between align-items-center my-1">
                                                                        <strong>Required Unit :</strong>
                                                                        <p className="mb-0 f-w-500">{el.requiredProduct}</p>
                                                                    </div>

                                                                    <div className="d-flex justify-content-between align-items-center my-1">
                                                                        <strong>Completed Unit:</strong>
                                                                        <p className="mb-0 f-w-500">{el.completedProduct}</p>
                                                                    </div>

                                                                </div>
                                                            ))
                                                        ) : (
                                                            <p className="text-center">No records found.</p>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}


        </Layout >
    )
}

export default LevelWiseUserCount;